<template>
  <ul class="contact-list">
    <li class="out-going" v-for="item in callHistory" v-if="item.call_disconnected_time && item.call_accepted_time && item.wallet_amount">
      <div class="calling-icon">
        <img :src='require("../assets/images/call-dail.svg")' alt="call" />
      </div>
      <div class="content">
        <div class="details">
          <h3>{{callDuration(item.call_disconnected_time, item.call_accepted_time)}}</h3>
          <span>{{new Date(item.call_requested_time*1000).toLocaleDateString()}}</span>
          <!-- 08/02/2020 | 09:30 PM -->
        </div>
        <div class="timing" v-if="item.wallet_amount.gems">
          <h4>{{item.wallet_amount ? item.wallet_amount.gems : '0.00'}}</h4>
          <span>{{$t('gems')}}</span>
        </div>
        <!-- <div class="timing" v-if="item.wallet_amount.wallet">
          <h4>{{item.wallet_amount ? item.wallet_amount.wallet : '0.00'}}</h4>
          <span>{{$t('wallet')}}</span>
        </div> -->
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: "CallHistoryList",
  components: {},
  props: {
    callHistory: Array
  },
  data() {
    return {
      Minutes: "00",
      Seconds: "00"
    };
  },
  computed: {},
  methods: {
    callDuration(callEnd, callAccept) {
      let remaningTime = new Date(callEnd - callAccept) * 1000;
      let seconds = Math.floor((remaningTime / 1000) % 60).toString();
      let minutes = Math.floor((remaningTime / 1000 / 60) % 60).toString();
      let hours = Math.floor((remaningTime / (1000 * 60 * 60)) % 24).toString();
      return `${this.twoDigit(hours)}:${this.twoDigit(minutes)}:${this.twoDigit(
        seconds
      )}`;
    },
    twoDigit(digit) {
      return Number(digit) > 0 ? (digit && digit.length > 1) ? digit : `0${digit}` : `00`
    }
  }
};
</script>
